import {BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV} from 'constants/general'
import axios from 'axios'
import { decodeStorage } from 'functions/storageBase64'

export async function getMovements({cardending, period}){
    let apiURL
    const no_internet = decodeStorage('sears_numero_internet')
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/cards/${cardending}/movements?NoInternet=${no_internet}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardending}/movements?NoInternet=${no_internet}`
    }

    const access_token = decodeStorage('access_token')

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getStatement(cardendingPayment){
    let apiURL
   const no_internet = decodeStorage('sears_numero_internet')
    const lastConsultData = decodeStorage('lastConsultData')
    // let no_internet = lastConsultData[0]?.noInternet

    // console.log('no_internet-getStatement: ', no_internet)

    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/cards/${cardendingPayment}/statement?NoInternet=${no_internet}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardendingPayment}/statement?NoInternet=${no_internet}`
    }

    const access_token = decodeStorage('access_token')

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getStatementOtherCard(noInternetPayment, cardending){
    const access_token = decodeStorage('access_token')

    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/other-cards/statement?NoInternet=${noInternetPayment}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/other-cards/statement?NoInternet=${noInternetPayment}`
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}